<template>
    <not-found v-if="job === null"></not-found>
    <router-view v-else :department="department" :deptinfo="dept_info" :locations="locations"></router-view>
</template>

<script>
  import NotFound from './NotFound.vue';

  export default {
    name: 'Single',
    props: ['id'],
    components: {
      'not-found': NotFound,
    },
    data() {
      return {
        job: window.careers_data.job_post,
      }
    },
    computed: {
      department: function(){
        return this.job.departments[0];
      },
      other_job_posts: function(){
        const job_id = this.job.internal_job_id;
        let job_posts = this.$root.source.job_data.jobs.filter(
            item => {
              return item.internal_job_id === job_id;
            }
        );

        return job_posts
      },
      locations: function(){
        return this.job.AdditonalLoc ? this.job.AdditonalLoc.split('; ') : '';
      },
      dept_info: function(){
        let department = this.$root.source.departments.filter(
            item => {
              return item.dept_ID === this.department;
            }
        )[0];

        let fallback = this.$root.source.departments[0];

        return department ? department : fallback;
      },
    },
    beforeCreate() {
      if (careers_data.job_post !== null) {
        // Set Product department as default value if none is given
        if (!careers_data.job_post.departments.length) {
          careers_data.job_post.departments[0] = {
            id: 65749,
            name: "R&D"
          };
        }
      }
    }
  };
</script>
